import {TextareaVariable} from '../types'
import {textareaWithVariables_parseValueToDOM} from '../dom/parse-value'
import {textareaWithVariables_normalizePillSpacers} from '../pill/normalize-spacers'
import {textareaWithVariables_isSpacer} from '../pill/is-spacer'


// Insert plain text at the current caret, re-tokenising against
// `tokens`. Returns true if anything was inserted. Caller should call
// `e.preventDefault()` before invoking this, and emit a change after.
//
// `tokens` may be the active tokens map (preview mode) or an empty
// map (source mode — preserves `{TOKEN}` literals as plain text).
export function textareaWithVariables_pastePlainText(
    editor : HTMLElement,
    text   : string,
    tokens : Map<string, TextareaVariable>,
): boolean {
    if (!text) return false

    const sel = window.getSelection()
    if (!sel || sel.rangeCount === 0) return false
    const range = sel.getRangeAt(0)
    range.deleteContents()

    const frag = textareaWithVariables_parseValueToDOM(text, tokens)
    const lastChild = frag.lastChild
    range.insertNode(frag)

    // Normalise first, then place the caret after the last inserted node
    // (and past its trailing edge-spacer if normalise added one).
    textareaWithVariables_normalizePillSpacers(editor)

    if (lastChild) {
        const tail   = lastChild.nextSibling
        const anchor = (tail && textareaWithVariables_isSpacer(tail)) ? tail : lastChild
        const caret  = document.createRange()
        caret.setStartAfter(anchor)
        caret.collapse(true)
        sel.removeAllRanges()
        sel.addRange(caret)
    }
    return true
}
